import AppModal from '@components/AppModal';
import Text from '@components/Text';
import { ActivityComponentType } from '@stackflow/react';
import { Trans, useTranslation } from 'react-i18next';

import useIdentifyForEasyCardPin from '../common/hooks/useIdentifyForEasyCardPin';

declare module '@stackflow/config' {
    interface Register {
        EasyCardPinLockedModal: {};
    }
}

/** PIN 입력 횟수 초과 안내. 확인을 누르면 PIN 재설정을 위한 본인인증으로 넘어간다 */
const EasyCardPinLockedModal: ActivityComponentType<'EasyCardPinLockedModal'> = () => {
    const { t } = useTranslation('easyCard');
    const { handleIdentity } = useIdentifyForEasyCardPin();
    return (
        <AppModal title={t('pin.lockedModal.title')}
            confirm={t('pin.lockedModal.confirm')}
            onConfirm={handleIdentity} >
            <Text align='center' size='title'>
                <Trans ns='easyCard'
                    i18nKey='pin.lockedModal.description'
                    components={{ br: <br/> }} />
            </Text>
        </AppModal>
    );
};

export default EasyCardPinLockedModal;
